module.exports = __webpack_public_path__ + "img/home__pl35——zh.a201c51b.png";